"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _heading = _interopRequireDefault(require("../heading"));
var _paragraph = _interopRequireDefault(require("../paragraph"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
// Tile
// ====

class Tile extends _react.default.Component {
  renderRetailer() {
    if (this.props.retailer) {
      return /*#__PURE__*/_react.default.createElement(_paragraph.default, {
        type: "medium",
        className: _indexModule.default.retailer
      }, this.props.retailer);
    }
    return undefined;
  }
  renderDate() {
    if (this.props.date) {
      return /*#__PURE__*/_react.default.createElement(_heading.default, {
        type: "small",
        className: _indexModule.default.date
      }, this.props.date);
    }
    return undefined;
  }
  render() {
    const tileClassNames = (0, _classnames.default)(_indexModule.default.Tile, this.props.classNames.tile);
    const infoClassNames = (0, _classnames.default)(_indexModule.default.info, {
      [_indexModule.default.infoBorder]: this.props.infoBorder,
      [_indexModule.default.darkInfo]: this.props.darkInfo
    }, this.props.classNames.info);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: tileClassNames
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _indexModule.default.hero
    }, this.props.hero), /*#__PURE__*/_react.default.createElement("div", {
      className: infoClassNames
    }, this.renderRetailer(), /*#__PURE__*/_react.default.createElement(_heading.default, {
      type: "medium",
      className: _indexModule.default.title
    }, this.props.title), this.renderDate()));
  }
}
exports.default = Tile;
Tile.propTypes = {
  hero: _propTypes.default.node.isRequired,
  classNames: _propTypes.default.object,
  infoBorder: _propTypes.default.bool,
  darkInfo: _propTypes.default.bool,
  retailer: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  date: _propTypes.default.string
};
Tile.defaultProps = {
  classNames: {}
};